import React, { Fragment } from 'react'
import { Box, TextField, Chip, useTheme, useMediaQuery } from '@mui/material'
import { CollapsibleInputCard } from '../../../components/_WMS/CollapsibleInputCard'
import { LoadingButton } from '../../../components/_EOS/Button/LoadingButton/LoadingButton'
import { formatExpirationDate } from '../../../utils/dateHelper'

interface OriginPositionSectionProps {
  originInputRef: React.RefObject<HTMLInputElement>
  localOriginPosition: string
  setLocalOriginPosition: (value: string) => void
  originValidated: boolean
  originValidationFailed: boolean
  isValidating: boolean
  handleValidateOrigin: () => void
  handleEditOrigin: () => void
  sharedState: {
    posicionOrigen: string
    selectedBatch?: {
      batchNumber: string
      expirationDate?: string | null
    }
    availableStock?: number
  }
}

export const OriginPositionSection: React.FC<OriginPositionSectionProps> = ({
  originInputRef,
  localOriginPosition,
  setLocalOriginPosition,
  originValidated,
  originValidationFailed,
  isValidating,
  handleValidateOrigin,
  handleEditOrigin,
  sharedState
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box mb={1}>
      <CollapsibleInputCard
        title="Posición de Origen"
        isValidated={originValidated}
        validationFailed={originValidationFailed}
        onEdit={handleEditOrigin}
        isMobile={isMobile}
        expandedContent={
          <Box display="flex" flexDirection={isMobile ? 'column' : 'row'}>
            <TextField
              inputRef={originInputRef}
              label="Código de Posición"
              variant="outlined"
              fullWidth
              value={localOriginPosition}
              onChange={(e) => setLocalOriginPosition(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleValidateOrigin()
                }
              }}
              error={originValidationFailed}
              style={{
                marginRight: isMobile ? 0 : theme.spacing(1),
                marginBottom: isMobile ? theme.spacing(2) : 0
              }}
            />
            <LoadingButton
              loading={isValidating}
              variant="contained"
              color="primary"
              onClick={handleValidateOrigin}
              disabled={!localOriginPosition.trim()}
              fullWidth={isMobile}
              style={{ minWidth: isMobile ? 'auto' : '100px' }}
            >
              Validar
            </LoadingButton>
          </Box>
        }
        collapsedSummary={`Posición Origen: ${sharedState.posicionOrigen}`}
        collapsedChips={
          <Box display="flex" flexWrap="wrap">
            {sharedState.selectedBatch ? (
              <Fragment>
                <Chip
                  label={`Lote: ${sharedState.selectedBatch.batchNumber}`}
                  color="primary"
                  size="small"
                  style={{
                    marginRight: sharedState.selectedBatch.expirationDate ? theme.spacing(1) : 0
                  }}
                />
                {sharedState.selectedBatch.expirationDate && (
                  <Chip
                    label={`Vence: ${formatExpirationDate(sharedState.selectedBatch.expirationDate, 'dd-MM-yyyy')}`}
                    style={{ backgroundColor: theme.palette.warning.light, color: theme.palette.warning.contrastText }}
                    size="small"
                  />
                )}
              </Fragment>
            ) : (
              <Chip
                label={`Stock: ${sharedState.availableStock} unidades`}
                color="primary"
                variant="outlined"
                size="small"
              />
            )}
          </Box>
        }
      />
    </Box>
  )
}